<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100">
    <div class="bg-white p-8 rounded shadow-md w-full max-w-2xl">
      <h2 class="text-2xl font-semibold text-gray-800 mb-6">
        Crear nueva vacante
      </h2>
      <form @submit.prevent="submitForm">
        <div class="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label
              for="jobTitle"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Título<span class="text-red-500">*</span></label
            >
            <input
              type="text"
              id="jobTitle"
              v-model="formData.jobTitle"
              required
              class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label
              for="company"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Empresa<span class="text-red-500">*</span></label
            >
            <input
              type="text"
              id="company"
              :value="companyName"
              readonly
              class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label
              for="workplaceType"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Tipo de Trabajo<span class="text-red-500">*</span></label
            >
            <select
              id="workplaceType"
              v-model="formData.workplaceType"
              required
              class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Onsite">Presencial</option>
              <option value="Hybrid">Híbrido</option>
              <option value="Remote">Remoto</option>
            </select>
          </div>
          <div>
            <label
              for="employeeLocation"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Ubicación (ciudad)<span class="text-red-500">*</span></label
            >
            <input
              type="text"
              id="employeeLocation"
              v-model="formData.employeeLocation"
              required
              class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label
              for="jobType"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Tipo de Asignación<span class="text-red-500">*</span></label
            >
            <select
              id="jobType"
              v-model="formData.jobType"
              required
              class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Full time">Tiempo Completo</option>
              <option value="Part time">Medio Tiempo</option>
              <option value="Volunteer">Servicio Social</option>
              <option value="Internship">Prácticas Profesionales</option>
              <!--<option value="Contract">Contrato</option>-->
              <option value="Temporary">Posición Temporal</option>
              <option value="Other">Otro</option>
            </select>
          </div>
        </div>

        <div class="mb-4">
          <label
            for="description"
            class="block text-sm font-medium text-gray-700 mb-1"
            >Descripción del puesto<span class="text-red-500">*</span></label
          >
          <textarea
            id="description"
            v-model="formData.description"
            rows="10"
            required
            class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
        </div>
        <div class="flex justify-end mt-6">
          <button
            type="submit"
            class="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Crear Vacante
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";
import { signInWithCustomToken } from "firebase/auth";

async function getCustomTokenFromBackend(firebaseIdToken) {
  try {
    const response = await fetch("/api/get-custom-token", {
      // Replace with your backend URL
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ firebaseIdToken }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch custom token: ${response.status} ${JSON.stringify(
          errorData
        )}`
      );
    }
    const data = await response.json();
    if (!data.customToken) {
      throw new Error(
        `Failed to fetch custom token, missing token ${JSON.stringify(data)}`
      );
    }
    return data.customToken;
  } catch (error) {
    console.error("Error getting the custom token:", error);
    throw error;
  }
}

export default {
  data() {
    return {
      formData: {
        jobTitle: "",
        workplaceType: "Onsite",
        employeeLocation: "",
        jobType: "Full time",
        description: "",
      },
      companyName: "",
    };
  },
  async created() {
    try {
      // 1. Get the Firebase ID token (original)
      const firebaseIdToken = await auth.currentUser.getIdToken();
      // 2. Get the custom token from backend
      const customToken = await getCustomTokenFromBackend(firebaseIdToken);
      // 3. Authenticate with custom token using signInWithCustomToken
      await signInWithCustomToken(auth, customToken);
      // 4. Get the token to use in the Authorization header (use firebase.auth().currentUser.getIdToken())
      const token = await auth.currentUser.getIdToken();
      // Fetch Company Info (name)
      const companyResponse = await fetch("/api/company-names", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!companyResponse.ok) {
        throw new Error(
          `HTTP error! status: ${companyResponse.status}`
        );
      }
      const companyData = await companyResponse.json();

      this.companyName = companyData[0]?.name;
    } catch (error) {
      console.error("Error getting company name", error);
      this.companyName = "Error obtaining company name";
    }
  },
  methods: {
     async submitForm() {
      try {
        // 1. Get the Firebase ID token (original)
        const firebaseIdToken = await auth.currentUser.getIdToken();
        // 2. Get the custom token from backend
        const customToken = await getCustomTokenFromBackend(firebaseIdToken);
        // 3. Authenticate with custom token using signInWithCustomToken
         await signInWithCustomToken(auth, customToken);
        // 4. Get the token to use in the Authorization header (use firebase.auth().currentUser.getIdToken())
         const token = await auth.currentUser.getIdToken();
          const response = await fetch('/api/create-vacancy', {
              method: 'POST',
              headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                 },
              body: JSON.stringify(this.formData),
          });

          if (!response.ok) {
               const errorData = await response.json();
                  throw new Error(
                `HTTP error! status: ${response.status} ${JSON.stringify(errorData)}`
                );
            }

           const responseData = await response.json();
           console.log('Vacancy created successfully: ', responseData);
           alert("Vacancy created!");
           this.$router.push("/dashboard");
           this.formData = {
                jobTitle: '',
                workplaceType: 'Onsite',
                employeeLocation: '',
                jobType: 'Full time',
                description: '',
              };
        } catch(error){
          console.error("Error creating vacancy:", error);
           alert(`Error creating vacancy ${error.message}`);
        }
      },
  },
};
</script>